import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getApplicationPhaseList as getApplicationPhaseListApi,
	getApplicationPhase as getApplicationPhaseApi,
	addNewApplicationPhase as addNewApplicationPhaseApi,
	updateApplicationPhase as updateApplicationPhaseApi,
	deleteApplicationPhase as deleteApplicationPhaseApi,
} from '../../helpers/normative/backend_helper';

export const getApplicationPhaseList = createAsyncThunk('application_phase/getApplicationPhaseList', async () => {
	try {
		const response = getApplicationPhaseListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getApplicationPhase = createAsyncThunk('application_phase/getApplicationPhase', async application_phase_id => {
	try {
		const response = getApplicationPhaseApi(application_phase_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewApplicationPhase = createAsyncThunk('application_phase/addNewApplicationPhase', async application_phase => {
	try {
		const response = addNewApplicationPhaseApi(application_phase);
		toast.success('Fase de aplicación agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar Fase de aplicación.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateApplicationPhase = createAsyncThunk('application_phase/updateApplicationPhase', async (application_phase) => {
		try {
			const response = updateApplicationPhaseApi(application_phase);
			toast.success('Fase de aplicación actualizada exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar Fase de aplicación.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteApplicationPhase = createAsyncThunk('application_phase/deleteApplicationPhase', async application_phase => {
	try {
		const response = await deleteApplicationPhaseApi(application_phase);
		toast.success('Fase de aplicación eliminado exitosamente.', { autoClose: 3000 });
		return { application_phase, ...response };
	} catch (error) {
		toast.error('Error al eliminar Fase de aplicación.', { autoClose: 3000 });
		throw new Error(error);
	}
});
